import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from 'redux';
import CircuitHistory from "./circuit-history.component";
import Translation from "../../../../common/translation/translation.component";
import { circuitHistoryActions } from "../../../../../store/external/inventory/history/circuit-history.reducer";
import { inventoryOrderHistoryActions } from "../../../../../store/external/inventory/history/order-history.reducer";
import OrderHistory from "./order-history.component";
import { HistoryLayout } from "../../../../common/history/history-layout.component";
class DetailsHistory extends Component{
    constructor(props) {
        super(props);
        this.state = {
            selectedIndex: "0",
            enableSearchBox: false,
            extractAlertMsg: ""
        };
        this.onChangeExtractAlertMsg = this.onChangeExtractAlertMsg.bind(this);
    }

    getSelectedIndex(value){
        this.setState({selectedIndex:value})
    }

    displaySearchBox(value){
        this.setState({enableSearchBox:value})
    }

    onClickExtract = () => {
        const { circuitId, extractCircuitHistoryLogs, extractOrderHistory } = this.props;
        const { extractAlertMsg, selectedIndex } = this.state;
        if (window.confirm(extractAlertMsg)) {
            if (selectedIndex === "0") {
                extractCircuitHistoryLogs(circuitId);
            }
            if (selectedIndex === "1") {
                extractOrderHistory(circuitId);
            }
            else {
                return;
            }
        }
    }

    onChangeExtractAlertMsg = (val, key) => {
        this.setState({
            extractAlertMsg: val
        });
    }

    render(){        
        return (
            <>
                <Translation
                    getOnlyText={true}
                    onChangeTranslation={this.onChangeExtractAlertMsg}
                    translationKey={"export_alert_message"} />

                <HistoryLayout 
                    listHistoryTab={this.props.listHistoryTab}
                    selectedIndex={this.getSelectedIndex.bind(this)}
                    extractAction={this.onClickExtract}
                    displaySearchBox={this.displaySearchBox.bind(this)}
                    isReadOnly={this.props.isReadOnly}
                    isReadAndExtractOnly={this.props.isReadAndExtractOnly}
                    isReadAndWrite={this.props.isReadAndWrite}
                >
                    
                    {
                        this.state.selectedIndex === "0" &&
                        <CircuitHistory circuitId={this.props.circuitId} displaySearch={this.state.enableSearchBox} />
                    }
                    {
                        this.state.selectedIndex === "1" &&
                        <OrderHistory circuitId={this.props.circuitId} handelLink={this.props.handelOrderHistorySelected} displaySearch={this.state.enableSearchBox} />
                        
                    }
                </HistoryLayout>     
                           
            </>
        )
    }
}

export default connect(
    state => {
        return {};
    },
    dispatch => bindActionCreators(
        Object.assign({}, circuitHistoryActions, inventoryOrderHistoryActions),
        dispatch
    )
)(DetailsHistory);